import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

export interface DialogData {
  user_id: string,
  first_name: string,
  last_name: string,
  assignStatus: string,
  projectData: any,
  isPublicUrl: string,
  token: string,
  invoiceId: string
}

@Component({
  selector: 'app-all-mockup-revision',
  templateUrl: './all-mockup-revision.component.html',
  styleUrls: ['./all-mockup-revision.component.css']
})
export class AllMockupRevisionComponent implements OnInit {
  private invoiceId: string;
  public currentMessage = {};
  public userDetails: any = {};
  public printLoc: string;
  public activeProjectkey = 0;
  public activeLocIndex = 0;
  public isProcessing = { mockup_approval_notes: false, revision: false };
  public loading = false;
  constructor(public dialogRef: MatDialogRef<AllMockupRevisionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router) { }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.printLoc = this.data.projectData[this.activeProjectkey].active_location_arr[this.activeLocIndex].emblocation_id;
    this.activeLocationData();
  }

  activeLocationData() {
    if (this.printLoc) {
      this.currentMessage[this.printLoc] = {
        revision: '',
        mockup_approval_notes: ''
      };
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
    if (this.invoiceId) {
      this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/invoices/" + this.invoiceId]));
    }
  }

  nextMockup() {
    this.activeLocIndex = this.activeLocIndex + 1;
    if (this.data.projectData[this.activeProjectkey].active_location_arr.length >= (this.activeLocIndex + 1)) {
      this.printLoc = this.data.projectData[this.activeProjectkey].active_location_arr[this.activeLocIndex].emblocation_id;
      this.activeLocationData();
    }
    else {
      if (this.data.projectData.length > this.activeProjectkey + 1) {
        this.activeProjectkey = this.activeProjectkey + 1;
        this.activeLocIndex = 0;
        this.printLoc = this.data.projectData[this.activeProjectkey].active_location_arr[this.activeLocIndex].emblocation_id;
        this.activeLocationData();
      }

    }
  }

  prevMockup() {
    if (this.activeLocIndex > 0) {
      this.activeLocIndex = this.activeLocIndex - 1;
      this.printLoc = this.data.projectData[this.activeProjectkey].active_location_arr[this.activeLocIndex].emblocation_id;
      this.activeLocationData();
    }
    else {
      if (this.activeProjectkey > 0) {
        this.activeProjectkey = this.activeProjectkey - 1;
        this.activeLocIndex = this.data.projectData[this.activeProjectkey].active_location_arr.length - 1;
        this.printLoc = this.data.projectData[this.activeProjectkey].active_location_arr[this.activeLocIndex].emblocation_id;
        this.activeLocationData();
      }

    }

  }

  sendReply = function (msgType) {
    this.isProcessing[msgType] = true;
    this.loading = true;
    let pKey = this.activeProjectkey;
    let projectKey = this.activeProjectkey + 1;
    let printLocs = this.printLoc;
    let msgKey = (msgType == 'invoice') ? 'comments' : (msgType == 'revision') ? 'revisions' : 'mockup_approval_notes';
    let apiMethod = (msgType == 'revision') ? 'mockup/revision' : 'mockup/approved';
    let messageOptions = {
      id: this.data.user_id,
      invoice_id: this.data.invoiceId,
      project: projectKey,
      location: printLocs,
      message: this.currentMessage[printLocs][msgType]
    }

    if (this.currentMessage[printLocs][msgType]) {
      this.CommonService.apiService(
        "POST",
        apiMethod,
        messageOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          if (response.status === true) {
            if (msgType == 'mockup_approval_notes') {
              if (this.data.projectData[pKey].messages && this.data.projectData[pKey].messages[printLocs]) {
                this.data.projectData[pKey].messages[printLocs][msgKey] = {
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.data.first_name,
                  last_name: this.data.last_name,
                  created_at: new Date(),
                  type:'User'
                };


              }
              else {
                Object.assign(this.data.projectData[pKey], {
                  messages: {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.data.first_name,
                        last_name: this.data.last_name,
                        created_at: new Date(),
                        type:'User'
                      }]
                    }
                  }
                });

              }
            }
            else {
              if (this.data.projectData[pKey].messages && this.data.projectData[pKey].messages[printLocs] && this.data.projectData[pKey].messages[printLocs][msgKey]) {
                this.data.projectData[pKey].messages[printLocs][msgKey].unshift({
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.data.first_name,
                  last_name: this.data.last_name,
                  created_at: new Date(),
                  type:'User'
                });

              }
              else {
                if (this.data.projectData[pKey].messages && this.data.projectData[pKey].messages[printLocs]) {
                  Object.assign(this.data.projectData.messages[printLocs], {

                    [msgKey]: [{
                      message: this.currentMessage[printLocs][msgType],
                      first_name: this.data.first_name,
                      last_name: this.data.last_name,
                      created_at: new Date(),
                      type:'User'
                    }]

                  });

                }
                else if (this.data.projectData[pKey].messages) {
                  Object.assign(this.data.projectData[pKey].messages, {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.data.first_name,
                        last_name: this.data.last_name,
                        created_at: new Date(),
                        type:'User'
                      }]
                    }

                  });


                }
                else if (!this.data.projectData[pKey].messages) {
                  Object.assign(this.data.projectData[pKey], {
                    messages: {
                      [printLocs]: {
                        [msgKey]: [{
                          message: this.currentMessage[printLocs][msgType],
                          first_name: this.data.first_name,
                          last_name: this.data.last_name,
                          created_at: new Date(),
                          type:'User'
                        }]
                      }
                    }
                  });
                }

              }
            }
            this.currentMessage[this.printLoc][msgType] = '';



          }
          if (msgKey != 'comments' && msgKey != 'revisions') {
            let activeIndex = this.data.projectData[pKey]['active_location_arr'].findIndex(x => x.emblocation_id == printLocs);
            if ((this.data.projectData[pKey]['active_location_arr'].length == activeIndex + 1) && (this.data.projectData.length == this.activeProjectkey + 1)) {
              this.dialogRef.close();
            }
            else {
              this.nextMockup();
            }

            // if (this.data.projectData[pKey]['active_location_arr'].length > activeIndex + 1) {
            //   console.log('egiht data',msgKey);
            //   this.printLoc = this.data.projectData[pKey]['active_location_arr'][activeIndex + 1]
            //   this.activeLocationData();

            // }
            // else {
            //   this.dialogRef.close();

            // }



            if (this.data.isPublicUrl != 'Yes') {
              this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/invoices/" + this.data.activeMockupData.invoiceId]));
            }
            else {

              this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/invoice/" + this.data.token]));

            }

          }
        },
        err => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          console.log(err);
        }
      );

    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-order/all-mockup-revision/all-mockup-revision.component.ts